/** CoStar.Api.ConsumerUserData.Denylist.DenylistType */
export var DenylistType;
(function (DenylistType) {
    DenylistType[DenylistType["Email"] = 1] = "Email";
    DenylistType[DenylistType["Phone"] = 2] = "Phone";
    DenylistType[DenylistType["Place"] = 3] = "Place";
})(DenylistType || (DenylistType = {}));
/** CoStar.Api.ConsumerUserData.Denylist.DenylistSearchType */
export var DenylistSearchType;
(function (DenylistSearchType) {
    DenylistSearchType[DenylistSearchType["Email"] = 1] = "Email";
    DenylistSearchType[DenylistSearchType["Phone"] = 2] = "Phone";
    DenylistSearchType[DenylistSearchType["Place"] = 3] = "Place";
    DenylistSearchType[DenylistSearchType["PlaceName"] = 4] = "PlaceName";
})(DenylistSearchType || (DenylistSearchType = {}));
